module.exports = __webpack_public_path__ + "static/img/powerprotect数据表.ed3a9930.png";